<template>
  <layout-breadcrumb-cartao
    cartaoCustom
    titulo="Detalhes do Prestador"
    :breadcrumb="bread"
    :iconeSvg="PrestadoresSvg"
  >
    <div slot="cartao">
      <unicom-linha>
        <unicom-coluna sm="12">
          <CartaoInformacoes
            :loading="loadingPrestador"
            :objetoInformacoes="objetoPrestador"
          />
        </unicom-coluna>
        <unicom-coluna sm="12">
          <transition name="fade">
            <CartaoTab
              v-if="iniciado"
              @iniciar-prestador="inicializarPrestador"
              :exibeAbaDeExclusao="exibeAbaDeExclusao"
              :codigoUnimed="codigoUnimed"
              :podeEnviarArquivo="podeEnviarArquivo"
              :podeAprovarReprovar="podeAprovarReprovar"
              :idRnpPrestador="idRnpPrestador"
            />
          </transition>
        </unicom-coluna>
      </unicom-linha>
    </div>
  </layout-breadcrumb-cartao>
</template>

<script>
import CartaoInformacoes from "./shared/componentes/CartaoInformacoes";
import CartaoTab from "./shared/componentes/CartaoTab";
import PrestadorDetalheMixin from "./shared/PrestadorDetalheMixin";

export default {
  mixins: [PrestadorDetalheMixin],
  components: {
    CartaoInformacoes,
    CartaoTab
  },
  data() {
    return {
      bread: [
        { titulo: "Início", url: "/home" },
        { titulo: "Prestadores", url: "/prestadores" },
        { titulo: "Detalhes do Prestador" }
      ]
    };
  }
};
</script>
